import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAVIGATION_ITEMS } from '../../../constants/navigation';
import { APP_CONFIG } from '../../../constants/config';
import './Header.css';

/**
 * Componente Header
 * Barra de navegación principal del sitio
 */
const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();

    // Detectar scroll
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
            <div className="container">
                <div className="header__content">
                    {/* Logo */}
                    <Link to="/" className="header__logo">
                        <div className="header__logo-container">
                            <img
                                src="/assets/images/logo.png"
                                alt="Logo"
                                className="header__logo-image"
                            />
                            <img
                                src="/assets/images/logoText.png"
                                alt="Logo"
                                className="header__logo-imgText"
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                }}
                            />
                            <h1 className="header__logo-text">{APP_CONFIG.shortName}</h1>
                        </div>
                    </Link>

                    {/* Menú de navegación - Desktop */}
                    <nav className="header__nav">
                        <ul className="header__nav-list">
                            {NAVIGATION_ITEMS.map((item) => (
                                <li key={item.id} className="header__nav-item">
                                    <Link
                                        to={item.path}
                                        className={`header__nav-link ${isActive(item.path) ? 'header__nav-link--active' : ''}`}
                                    >
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Botón hamburguesa - Mobile */}
                    <button
                        className="header__hamburger"
                        onClick={toggleMenu}
                        aria-label="Toggle menu"
                    >
                        <span className={`header__hamburger-line ${isMenuOpen ? 'header__hamburger-line--open' : ''}`}></span>
                        <span className={`header__hamburger-line ${isMenuOpen ? 'header__hamburger-line--open' : ''}`}></span>
                        <span className={`header__hamburger-line ${isMenuOpen ? 'header__hamburger-line--open' : ''}`}></span>
                    </button>
                </div>

                {/* Menú móvil */}
                <div className={`header__mobile-menu ${isMenuOpen ? 'header__mobile-menu--open' : ''}`}>
                    <ul className="header__mobile-nav-list">
                        {NAVIGATION_ITEMS.map((item) => (
                            <li key={item.id} className="header__mobile-nav-item">
                                <Link
                                    to={item.path}
                                    className={`header__mobile-nav-link ${isActive(item.path) ? 'header__mobile-nav-link--active' : ''}`}
                                    onClick={() => setIsMenuOpen(false)}
                                >
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </header>
    );
};

export default Header;
